/**
 * Spec 069 AC-D2 — who did it, by name, never by id: the server's `actorLabel` (+ " (you)" for the
 * signed-in member), else a role-only fallback for responses that predate the label.
 */
export function actorText(ev: { actorLabel?: string | null; actorRole?: string | null; actorId?: string | null }, selfId?: string | null): string {
  const label = ev.actorLabel?.trim();
  const you = !!selfId && !!ev.actorId && ev.actorId === selfId;
  if (label) return you ? `${label} (you)` : label;
  switch ((ev.actorRole ?? '').toUpperCase()) {
    case '': return '';
    case 'ADMIN':
    case 'SUPER_ADMIN': return 'Garagat admin';
    case 'CUSTOMER': return 'Customer';
    case 'SYSTEM': return 'System';
    default: return you ? 'You' : 'Garage team';
  }
}
